import type { HookFormSubmitHandler } from 'common/models';
import { ImageComponent } from 'components';
import { isProduction } from 'helpers/environmentHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';
import logo from 'static/images/logo_dark.png';

import type { TenantCodeFormValues } from './TenantCodeForm';
import TenantCodeForm from './TenantCodeForm';

interface Props {
  handleTenant: HookFormSubmitHandler<TenantCodeFormValues>;
}

const TenantPart: React.FC<Props> = (props): React.ReactElement => {
  const { handleTenant } = props;

  const { t } = useCustomTranslation();

  return (
    <>
      <div className="logo">
        <ImageComponent url={logo} className="img-fluid" />
      </div>
      <TenantCodeForm onSubmit={handleTenant} />
      <div className="links">
        {/* <Link to="/register" className="fake-button">
          {props.t("login.singupCompanyLink")}
        </Link> */}
        <a
          href={`${
            isProduction()
              ? 'https://www.mwork365.com/lead-form'
              : 'https://testwww.mwork365.cloud/lead-form'
          }`}
          target="_blank"
          rel="noopener noreferrer"
          className="fake-button"
        >
          {t('login.leadLink')}
        </a>
      </div>
    </>
  );
};

export default TenantPart;
